import { React, useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import styled from "styled-components";
import Lottie from 'lottie-react';

import { loadTossPayments } from "@tosspayments/tosspayments-sdk";

import FetchModule from "../../Model/Share/Network/FetchModule";

import LoadingAnimation from '../../Animation/LoadingAnimation.json';

// 고객키별 카드 등록 시도 횟수 저장 키 //
const ATTEMPT_KEY_PREFIX = 'CardRegistrationAttempt-';

// 동일 고객키 기준 카드 등록 시도 횟수 증가 //
function increaseAttemptCount(customerKey) {
  let key = ATTEMPT_KEY_PREFIX + customerKey;
  let count = parseInt(window.localStorage.getItem(key) || '0', 10) + 1;

  window.localStorage.setItem(key, count.toString());

  return count;
}

// 카드 등록 실패 사유 서버 기록 (실패 화면 전환 중 유실 방지를 위해 keepalive 사용) //
function sendRegistrationFailure(baseUrl, failureData) {
  try {
    fetch(baseUrl + '/api2/card/registration/failure', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(failureData),
      keepalive: true
    }).catch(() => {
      // 실패 기록 전송 오류는 무시 //
    });
  }
  catch (e) {
    // 실패 기록 전송 오류는 무시 //
  }
}

export default function CardRegistrationRequestPage({ match }) {
  const history = useHistory();

  // 토스 클라이언트 키 — Zone 프론트와 동일 상점 키, .env(REACT_APP_TOSS_CLIENT_KEY) 배선 //
  const TosspaymentsKey = process.env.REACT_APP_TOSS_CLIENT_KEY;
  const url = 'https://coach.link-zone.org';
  // const url = 'http://192.168.0.44:8080';

  // // 카드 등록을 위한 토클 발행 후 카드 등록 실행 //
  // useEffect(() => {
  //   window.localStorage.setItem('Token', 'Bearer ' + match.params.token);

  //   const fetchModule = new FetchModule();
  //   (
  //     async() => {
  //       const responseData = await fetchModule.getDataOfCoachVersion2('card/auth_publication', 'GET');

  //       if (responseData.status === 200) {
  //         let token = responseData.data.token;
  //         let userName = responseData.data.name;
  //         let phone = responseData.data.phone;

  //         const obj = {};

  //         obj.PCD_PAY_TYPE = 'card';
  //         obj.PCD_PAY_WORK = 'AUTH';
  //         // obj.PCD_PAY_WORK = 'PAY'
  //         obj.PCD_CARD_VER = '01';
  //         obj.PCD_PAYER_AUTHTYPE = 'sms';
  //         obj.PCD_PAYER_NAME = userName;
  //         obj.PCD_PAYER_HP = phone;
  //         // obj.PCD_RST_URL = '/failed/registration_card';
  //         obj.PCD_RST_URL = 'https://coach.link-zone.org/api2/card/direct/save/' + token;
  //         // obj.PCD_RST_URL = 'http://172.30.1.6:8080/api2/card/direct/save/' + token;


  //         // obj.callbackFunction = getResult;
  //         obj.clientKey = '0F44C92BFB07F1BE60C5235A7254316D';
  //         // obj.clientKey = 'test_DF55F29DA654A8CBC0F0A9DD4B556486';

  //         setTimeout(() => {
  //           window.PaypleCpayAuthCheck(obj);
  //         }, 1500)
  //       }
  //       else {
  //         history.push('/400/카드등록 절차가 실패하였습니다');
  //       }
  //     }
  //   )();
  // }, []);

  // 카드 등록을 위한 토클 발행 후 카드 등록 실행 //
  useEffect(() => {
    window.localStorage.setItem('Token', 'Bearer ' + match.params.token);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataOfCoachVersion2('card/auth_publication', 'GET');

        if (responseData.status === 200) {
          let token = responseData.data.token;
          let userName = responseData.data.name;
          let phone = responseData.data.phone;
          let userId = responseData.data.userId;
          let customerKey = responseData.data.customerKey;

          const tosspayments = await loadTossPayments(TosspaymentsKey);

          const brandPay = tosspayments.brandpay({
            customerKey: customerKey,
            redirectUrl: url + '/api2/card/registration/auth'
          })

          let startedAt = Date.now();
          let attemptNo = increaseAttemptCount(customerKey);

          brandPay.addPaymentMethod()
            .then(function (methods) {
              window.localStorage.removeItem(ATTEMPT_KEY_PREFIX + customerKey);

              // setTimeout(() => {
              let requestData = {
                userId: userId,
                customerKey: customerKey,
                token: token
              }

              const fetchModule = new FetchModule();
              (
                async () => {
                  const responseData = await fetchModule.postDataOfCoachVersion2('card/registration/success', 'POST', requestData);

                  if (responseData.status === 200) {
                    let encodedeMessage = encodeURIComponent('카드 등록이 완료되었습니다');

                    history.push('/complete/card_registration/200/' + encodedeMessage);
                  }
                  else {
                    let encodedeMessage = encodeURIComponent('카드 등록에 실패하였습니다');

                    history.push('/complete/card_registration/400/' + + encodedeMessage);
                  }
                }
              )();
              // }, 3000);
            })
            .catch((e) => {
              sendRegistrationFailure(url, {
                customerKey: customerKey,
                userId: userId,
                errorCode: e && e.code ? e.code : 'UNKNOWN',
                errorMessage: e && e.message ? e.message : '',
                errorName: e && e.name ? e.name : '',
                elapsedMs: Date.now() - startedAt,
                attemptNo: attemptNo,
                path: 'app',
                userAgent: window.navigator.userAgent
              });

              let encodedeMessage = encodeURIComponent('카드 등록에 실패하였습니다');

              history.push('/complete/card_registration/400/' + encodedeMessage);
            })
        }
        else {
          history.push('/400/카드등록 절차가 실패하였습니다');
        }
      }
    )();
  }, [TosspaymentsKey]);

  return (
    <TopLevelWrapper id='payment-method'>
      <LottieWrapper>
        <LottieBox>
          <Lottie animationData={LoadingAnimation} loop={true} />
        </LottieBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000'>결제 모듈 로딩중...</Text>
      </LottieWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;

  background-color: #FFFFFF;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const LottieBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 60px;
  height: 60px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize};

  color: ${props => props.color};

  margin: 0 0 0 0;
`;